import { render } from "./PageHeader.vue?vue&type=template&id=c0d13562"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0d13562"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0d13562', __exports__)) {
    api.reload('c0d13562', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=c0d13562", () => {
    api.rerender('c0d13562', render)
  })

}


export default __exports__